export interface BlogPostQueryError {
    statusCode?: number
    statusMessage?: string
}

export type BlogPostOutcome
    = | { kind: 'render' }
        | { kind: 'redirect' }
        | { kind: 'error', statusCode: number, statusMessage: string }

export function resolveBlogPostOutcome(error: BlogPostQueryError | null, hasPost: boolean): BlogPostOutcome {
    // Proxy maps missing posts to null; a 404-shaped error is only the route missing.
    if (error?.statusCode === 404 || (!error && !hasPost)) {
        return { kind: 'redirect' }
    }

    if (error) {
        return {
            kind: 'error',
            statusCode: error.statusCode ?? 503,
            statusMessage: error.statusMessage ?? 'Blog temporarily unavailable',
        }
    }

    return { kind: 'render' }
}
